<template>
  <div class="container py-4 col-12 col-lg-10" id="container">

    <!-- BREADCRUMB -->
    <!-- <nav class="mb-3 mb-md-5" aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item"><a href="/"><b>Início</b></a></li>
        <li class="breadcrumb-item active" aria-current="page">Assinatura</li>
      </ol>
    </nav> -->

    <!-- TÍTULO -->
    <div class="row mb-md-5 page-header">
      <div class="col-12">
        <p class="page-header-eyebrow">ASSINATURA</p>
        <h1 class="page-title mb-1">WISECALC PRO</h1>
        <p class="page-subtitle mb-0">
          Contrate agora e tenha acesso a recursos exclusivos.
        </p>
      </div>
    </div>

    <div v-if="mensagemBloqueio" class="alert alert-warning" role="alert">
      {{ mensagemBloqueio }}
    </div>

    <!-- CARD 1 — PLANO -->
    <div class="row" v-if="assinatura.status !== 'active' && assinatura.status !== 'trialing' && assinatura.status !== 'past_due' && assinatura.status !== 'vitalicia' && assinatura.status !== 'estudante' && assinatura.status !== 'fundador' || !assinatura.status">

      <div class="container-fluid col-12 col-md-8 col-lg-6 mx-auto">

        <div class="assinatura-card-venda">

          <!-- HEADER COM BADGE DE INAUGURAÇÃO -->
          <div class="d-flex justify-content-between align-items-center mb-2">
            <h5 class="mb-0 titulo-assinatura-card-venda">Plano Único</h5>
            <span class="badge badge-promocao">Oferta de Inauguração</span>
          </div>

          <p class="text-muted mb-3">
            Perfeito para profissionais e empresas que precisam de recursos avançados e acesso ilimitado.
          </p>

          <ul class="lista-beneficios">
            <li><b>Projetos ilimitados</b></li>
            <li><b>Componentes ilimitados</b></li>
            <li><b>Exportações em PDF ilimitadas</b></li>
            <li><b>Compartilhamento ilimitado</b></li>
            <li><b>Acesso a todas as calculadoras</b></li>
          </ul>

          <!-- PREÇO PROMOCIONAL -->
          <div class="bloco-preco mb-3">
            <span class="preco-antigo">R$ 89,90</span>
            <div class="preco">
              R$ <strong>59,90</strong> <small>/ mês</small>
            </div>
          </div>
          <button
            class="btn btn-primary botao-azul w-100"
            @click="iniciarCheckout"
          >
            Assinar plano
          </button>
        </div>
      </div>
    </div>

    <!-- CARD 2 — DETALHES -->
    <div
      v-if="assinatura.status === 'active' || assinatura.status === 'trialing' || assinatura.status === 'past_due' || assinatura.status === 'vitalicia' || assinatura.status === 'estudante' || assinatura.status === 'fundador'"
      class="row mt-4"
    >
      <div class="container-fluid col-12 col-md-8 col-lg-6 mx-auto">

        <div class="assinatura-card">

          <h5 class="mb-3 titulo-detalhes-assinatura">Detalhes da Assinatura</h5>

          <div class="linha-info">
            <span>Plano</span>
            <b>{{ assinatura.nome_assinatura }}</b>
          </div>

          <div class="linha-info">
            <span>Status</span>
            <span v-if="assinatura.status === 'active'" class="badge badge-ativo">Ativo</span>
            <span v-if="assinatura.status === 'trialing'" class="badge badge-ativo">Teste de 7 dias</span>
            <span v-if="assinatura.status === 'past_due'" class="badge badge-ativo">Pagamento atrasado</span>
            <span v-if="assinatura.status === 'vitalicia'" class="badge badge-ativo">Vitalícia</span>
            <span v-if="assinatura.status === 'estudante'" class="badge badge-ativo">Licença estudantil</span>
            <span v-if="assinatura.status === 'fundador'" class="badge badge-ativo">Plano fundador</span>
          </div>

          <div class="linha-info" v-if="assinatura.cancelado_ultimo_mes">
            <span>Situação</span>
            <span class="badge badge-ativo">Cancelado</span>
          </div>

          <div class="linha-info" v-if="assinatura.status !== 'vitalicia'">
            <span>{{ assinatura.status === 'estudante' || assinatura.status === 'fundador' ? 'Acesso válido até' : 'Próximo pagamento' }}</span>
            <b>{{ assinatura.data_fim_formatada }}</b>
          </div>

          <div class="linha-info" v-if="assinatura.status !== 'vitalicia' && assinatura.status !== 'estudante' && assinatura.status !== 'fundador'">
            <span>Valor</span>
            <b>{{ assinatura.valor }}/mês</b>
          </div>

          <div class="linha-info" v-if="assinatura.status !== 'vitalicia'">
            <span>Dias restantes</span>
            <b>{{ diasRestantes() }}</b>
          </div>

          <!-- Botões de ação -->
          <div class="row g-2 mt-4" v-if="assinatura.status !== 'vitalicia' && assinatura.status !== 'estudante' && assinatura.status !== 'fundador'">

            <div class="col-12">
              <button
                class="btn btn-primary botao-azul w-100"
                @click="corrigirPagamento"
              >
                Gerenciar assinatura
              </button>
            </div>

            <div v-if="assinatura.cancelado_ultimo_mes === false && assinatura.status === 'active'" class="col-12">
              <button
                class="btn btn-primary botao-azul w-100"
                data-bs-toggle="modal"
                data-bs-target="#confirmarCancelamentoModal"
              >
                Cancelar plano
              </button>
            </div>

            <div class="col-12" v-if="assinatura.cancelado_ultimo_mes === true">
              <button
                class="btn btn-primary botao-azul w-100"
                @click="reativarAssinatura"
              >
                Reativar plano
              </button>
            </div>

            <div class="col-12" v-if="assinatura.status === 'past_due'">
              <button
                class="btn btn-primary botao-azul w-100"
                @click="corrigirPagamento"
              >
                Corrigir pagamento
              </button>
            </div>

          </div>

        </div>
      </div>
    </div>

    <!-- MODAL CANCELAMENTO -->
    <div
      class="modal fade"
      id="confirmarCancelamentoModal"
      tabindex="-1"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">

          <div class="modal-header">
            <h5 class="modal-title">Cancelar Assinatura</h5>
            <button class="btn-close" data-bs-dismiss="modal"></button>
          </div>

          <div class="modal-body">
            Tem certeza de que deseja cancelar sua assinatura?
            Você ainda terá acesso até o final do período atual.
          </div>

          <div class="modal-footer"> 
            <button type="button" class="btn btn-secundario" data-bs-dismiss="modal">Não</button> 
            <button type="button" class="btn btn-primary botao-azul" @click="cancelarPlano()">Sim, cancelar</button> 
          </div>

        </div>
      </div>
    </div>

    <!-- MODAIS -->
    <AlertModal
      :visible="alertModal.visible"
      :title="alertModal.title"
      :message="alertModal.message"
      :type="alertModal.type"
      @close="fecharAlert"
    />

    <LoadingModal
      :visible="loading.visible"
      :title="loading.title"
      :message="loading.message"
    />

  </div>
</template>

<script>

import AlertModal from '@/componentesTelas/AlertModal.vue';
import LoadingModal from '@/componentesTelas/LoadingModal.vue';
import { carregarTipoUsuario, getUsuario } from '@/utils/authStorage';

export default {
  name: "Assinatura",
  data() {
    return {
      assinatura: {},
      usuarioLogado: null,
      cupom: '',

      // Modal genérico
      alertModal: {
        visible: false,
        title: '',
        message: '',
        type: 'info'
      },

      // Modal de loading
      loadingModal: null,
      loadingModalAberto: false,

      // Modal de loading
      loading: {
        visible: true,
      },
      mensagemBloqueio: '',
      agora: Date.now(),
      intervaloDiasRestantes: null
    };
  },
  components: {
    AlertModal,
    LoadingModal
  },
  async mounted() {
    this.abrirLoading();
    this.usuarioLogado = getUsuario();
    this.mensagemBloqueio = this.obterMensagemBloqueio();
    this.ajustarTamanhoCardPrincipal();

    const tipoUsuario = await carregarTipoUsuario();
    if (tipoUsuario === 'admin') {
      this.assinatura = {
        status: 'vitalicia',
        nome_assinatura: 'WISECALC PRO Vitalício',
        cancelado_ultimo_mes: false,
      };
      this.fecharLoading();
      return;
    }

    await this.carregarAssinatura();
    if (this.$route.query.reativar === '1') {
      await this.$router.replace({
        query: { ...this.$route.query, reativar: undefined }
      });
      this.reativarAssinatura(true);
    }

    this.intervaloDiasRestantes = window.setInterval(() => {
      this.agora = Date.now();
    }, 60 * 1000);

    // Adicione este listener
    const modalEl = document.getElementById('loadingModal');
    if (modalEl) {
      modalEl.addEventListener('hidden.bs.modal', () => {
        this.loadingModalAberto = false;
      });
    }
  },
  beforeUnmount() {
    if (this.intervaloDiasRestantes) {
      window.clearInterval(this.intervaloDiasRestantes);
    }
  },
  methods: {

    obterMensagemBloqueio() {
      const mensagens = {
        cancelada: 'Seu acesso foi bloqueado porque a assinatura foi cancelada. Reative a cobrança para continuar usando o WiseCalc.',
        'pagamento-atrasado': 'Seu acesso foi bloqueado porque o pagamento está atrasado. Corrija o pagamento para continuar usando o WiseCalc.',
        'sem-assinatura': 'Seu acesso foi bloqueado porque não há uma assinatura ativa fora do período de teste. Assine o plano para continuar usando o WiseCalc.',
        indisponivel: 'Não foi possível verificar sua assinatura agora. Tente novamente em instantes.'
      };

      return mensagens[this.$route.query.bloqueio] || '';
    },

    abrirAlert(title, message, type = 'info') {
      this.alertModal = {
        visible: true,
        title,
        message,
        type
      };
    },

    fecharAlert() {
      this.alertModal.visible = false;
    },

    abrirLoading() {
      this.loading.visible = true;
    },

    fecharLoading() {
      this.loading.visible = false;
    },

    ajustarTamanhoCardPrincipal() {
      const card = document.querySelector(".card-principal");
      if (card) {
        card.style.maxWidth = "1200px";
      }
    },

    async carregarAssinatura() {
      try {
        const res = await fetch(
          `${process.env.VUE_APP_BACKEND_URL}/buscar-assinatura`,
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ email: this.usuarioLogado.email })
          }
        );

        if (!res.ok) {
          throw new Error('Erro ao buscar assinatura');
        }

        const data = await res.json();
        this.assinatura = data.assinatura || {};

      } catch (err) {
        this.abrirAlert('Sistema', 'Não foi possível carregar os dados da assinatura.', 'danger');
      } finally {
        this.carregando = false;

        // Fecha o loading com leve delay (UX)
        setTimeout(() => {
          this.fecharLoading();
        }, 500);
      }
    },

    async iniciarCheckout() {
      const res = await fetch(
        `${process.env.VUE_APP_BACKEND_URL}/criar-checkout`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            email: this.usuarioLogado.email,
            semTrial: this.assinatura.status === 'canceled'
          })
        }
      );
      const data = await res.json();
      window.location.href = data.url;
    },

    async cancelarPlano() {
      const response = await fetch(
        `${process.env.VUE_APP_BACKEND_URL}/cancelar-assinatura`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ email: this.usuarioLogado.email })
        }
      );

      if (!response.ok) {
        const data = await response.json().catch(() => ({}));
        this.abrirAlert('Sistema', data.erro || 'Não foi possível cancelar a assinatura.', 'danger');
        return;
      }

      await this.carregarAssinatura();
      this.fecharModalCancelamento();
      this.abrirAlert('Assinatura', 'Sua assinatura foi cancelada. O acesso permanece disponível até o fim do período pago.', 'success');
    },

    async reativarAssinatura(retornoPortal = false) {
      this.abrirLoading();

      try {
        const response = await fetch(
        `${process.env.VUE_APP_BACKEND_URL}/reativar-assinatura`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ email: this.usuarioLogado.email })
        }
        );
        const data = await response.json();

        if (data.requerAtualizacaoCartao && data.url) {
          if (retornoPortal) {
            throw new Error(data.erro || 'Não foi possível efetivar a cobrança após atualizar o cartão.');
          }
          window.location.href = data.url;
          return;
        }

        if (!response.ok) {
          throw new Error(data.erro || 'Não foi possível reativar a assinatura.');
        }

        await this.carregarAssinatura();
        this.mensagemBloqueio = '';
        await this.$router.replace({
          query: {
            ...this.$route.query,
            bloqueio: undefined,
            reativar: undefined
          }
        });
        this.abrirAlert('Assinatura', 'Sua assinatura foi reativada com sucesso.', 'success');
      } catch (error) {
        this.abrirAlert('Sistema', error.message, 'danger');
      } finally {
        this.fecharLoading();
      }
    },

    fecharModalCancelamento() {
      const modal = document.getElementById('confirmarCancelamentoModal');
      if (modal && window.bootstrap?.Modal) {
        window.bootstrap.Modal.getOrCreateInstance(modal).hide();
      }
    },

    async corrigirPagamento() {
      const res = await fetch(`${process.env.VUE_APP_BACKEND_URL}/corrigir-pagamento`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          email: this.usuarioLogado.email
        })
      });

      // Redireciona para o portal de cobrança
      const data = await res.json();
      window.location.href = data.url;
    },

    diasRestantes() {
      const ts = this.assinatura?.data_fim_unix;
      if (!ts) return "-";
      const fim = ts > 9999999999 ? ts : ts * 1000;
      return Math.ceil((fim - this.agora) / 86400000);
    }
  }
};
</script>

<style scoped>
.badge-ativo {
  background-color: #E7F0FF;
  color: #0056FF;
  font-weight: 600;
  border-radius: 6px;
  padding: 10px 14px;
  font-size: 12px;
}

.lista-beneficios {
  list-style: none;
  padding: 0;
}

.lista-beneficios li::before {
  content: "✔";
  color: #22c55e;
  margin-right: 8px;
}

.linha-info {
  display: flex;
  justify-content: space-between;
  padding: 6px 0;
  font-size: 14px;
}

.btn-secundario {
  background-color: #EDEFF2 !important;
  color: #3E4449 !important;
  font-weight: 600;
  border-radius: 8px;
  padding: 10px 16px;
  border: none;
}

.btn-secundario:hover {
  background-color: #e2e5e9 !important;
  color: #3E4449 !important;
}

.assinatura-card, .assinatura-card-venda { 
  background: #fff; 
  border: 2px solid #E6ECF5; 
  border-radius: 12px; 
  padding: 20px; 
  max-width: 720px; 
  font-size: 12px;
  margin: 0 auto;
}

.assinatura-card-venda {
  background-color: #EDF7FF;
}

.titulo-assinatura-card-venda, .preco{
  font-size: 22px;
  font-weight: bold;
  color: #0056FF;
}

.titulo-detalhes-assinatura {
  font-weight: 800;
}

</style>
